export const PHONE_NOT_COVER = process.env.REACT_APP_TEL;

export const DOMAIN = process.env.REACT_APP_DOMAIN_LOCALE;

export const CALENDAR_MEET =
  DOMAIN === "wl_es"
    ? "https://meetings-eu1.hubspot.com/axa-life5/reunion"
    : "https://meetings-eu1.hubspot.com/life5-es/reunion";

export const ENV = process.env.REACT_APP_ENVIROMENT;

// translate() returns the key itself when a translation is missing; fall back
// to the generic label until the exclusions keys reach the translation source
const translateOr = (translate: any, key: string, fallbackKey: string) => {
  const value = translate(key);
  return value === key ? translate(fallbackKey) : value;
};

// Mapa slug -> etiqueta del listado de documentos descargables.
// OJO: `DownloadableFiles` (storybook) solo pinta la fila `if (label && type)`,
// así que un slug que la API devuelva y NO esté en este mapa se descarta EN
// SILENCIO: el usuario no ve el documento y no hay ningún error. Al dar de alta
// un documento hay que añadirlo aquí además de en el backend.
export const PARSE_DOCS: any = (translate: any) => {
  const offerWBase = translate("downloadableFiles.conditionsPdf");
  const offerMulti = translate("downloadableFiles.conditionsPdf");
  const ipaExclusions = translateOr(translate, "downloadableFiles.exclusionsIpaPdf", "downloadableFiles.conditionsPdf");
  const diseasesExclusions = translateOr(translate, "downloadableFiles.exclusionsDiseasesPdf", "downloadableFiles.conditionsPdf");
  return [{
    "offer-w-base": offerWBase,
    "offer-multi": offerMulti,
    "ipa-any-cause-exclusions": ipaExclusions,
    "serious-diseases-exclusions": diseasesExclusions,
    "legal-note": translate("downloadableFiles.notesPdf"),
    "ipid": translate("downloadableFiles.ipidPdf"),
    "devis": translate("downloadableFiles.devis"),
    "agl-budget": translate("downloadableFiles.aglBudget"),
    // Preventivo IT (offer-agl-it), servido por ms-documentator. translateOr porque
    // la clave vive en OTRO repositorio (getlife/translations, que se copia en build)
    // y puede desplegarse después que este mapa: mientras tanto cae a la etiqueta
    // genérica en vez de pintar la clave en crudo.
    "offer-agl-it": translateOr(translate, "downloadableFiles.preventivo", "downloadableFiles.conditionsPdf"),
    // OJO — `first-year-breakdown` se retiró a propósito de este mapa.
    // Su generador NO devuelve una URL: `GeneratePdfFirstYearBreakdownFromTwig`
    // escribe el PDF en `/tmp/<time>.pdf` del pod y `FirstYearBreakdownDocument-
    // Generator` devuelve ESA RUTA, que `GenerateDocumentsCommandHandler` envuelve
    // como `documentUrl`. Admin funciona porque hace `file_get_contents()` sobre
    // ella, pero aquí el navegador haría `window.open("/tmp/…pdf")` → 404.
    // No volver a añadirlo hasta que el generador devuelva una URL de verdad
    // (lo hará al cablearse contra ms-documentator, que emite URL firmada).
    // English variants: served to leads with preferred_locale='en'. The backend
    // returns them alongside the market-language entry, so we suffix "(EN)" to
    // tell them apart. Same label as the base — no new translation key needed.
    "offer-w-base-en": `${offerWBase} (EN)`,
    "offer-multi-en": `${offerMulti} (EN)`,
    "ipa-any-cause-exclusions-en": `${ipaExclusions} (EN)`,
    "serious-diseases-exclusions-en": `${diseasesExclusions} (EN)`,
  }];
}

export const GOOGLE_OAUTH_ID = process.env.REACT_APP_GOOGLE_OAUTH_ID;
